/* eslint-disable */
/* globals angular */
import intl from 'react-intl-universal'

import { htmlTextReducer } from '~/util/cleanPasteHTML'
import {
  giveContentElementsIds,
  handleOldFaultyPicklistOverrides,
  inflateToANS,
  inflatePicklists,
  overridePicklists,
  inflateMissingContentElements,
} from './inflation'
import {
  removeEmptyParagraphs,
  removeEmptyContentElementComments,
  removeBRPlaceholders,
  initializePaywallStatus,
} from './cleaning'
import storyCleanup from '~/util/storyCleanup'
import * as cloneService from './clone'
import {
  deflateInlineComments,
  inflateInlineComments,
} from '~/util/inlineComments'
import { storyLoadedAction } from '~/redux/appReducer'
import ArcUUID from '~/util/arc-identifiers'
import { cloneDeep, forEach, get, isError, isString, set } from 'lodash'
import { saveAction } from '~/redux/draftEditor'
import { constants } from '../../contenteditablebind/directive'
import { hasPermission } from '../permission'
import {
  shouldPopulateDistributor,
  populateDistributorFieldsFromSource,
} from '../distributor'
import CONSTANTS from '~/constants'
import { handlePicklistsError } from '~/modules/routes/initialLoads'
import {
  createStoryPubstack,
  updateDraftRevision,
  getStoryPubstack,
  bulkSaveCirculations,
  getAllCirculations,
  deleteStory,
} from '~/api/story'
import * as storyServicePubstackUtils from './story-pubstack'
import {
  getCirculation,
  setCirculation,
  setDocumentAction,
  setDraftRevisionAction,
  setStoryAns,
} from '~/redux/storyData'
import { utcToZonedTime, format } from 'date-fns-tz'
import { getCirculationsFromStoryTemplate } from '~/reactapp/App/CirculateTab/CirculateTab.utils'
import { validateStory } from '~/util/validation'
import { setVariants } from '../../../redux/storyData'
import { getFeatures } from '../../../featureFlags'
import axios from 'axios'
import fetchVariants from './fetchVariants'

export default [
  '$window',
  '$http',
  '$q',
  '$location',
  '$interval',
  '$timeout',
  '$rootScope',
  'storyTemplateService',
  'contentTemplatesService',
  'metaTemplatesService',
  'padlockService',
  'settingsService',
  'findReplaceService',
  'hyperlinkService',
  'toastr',
  '$ngRedux',
  'fnService',
  'uiStateManagerService',
  'pharosService',
  '$route',
  'featureFlagService',
  '$injector',
  'getErrorMessage',
  story,
]

export const channels = {
  basic: intl.get('story.channels.basic'),
  print: intl.get('story.channels.print'),
  mobile: intl.get('story.channels.mobile'),
  table: intl.get('story.channels.table'),
  native: intl.get('story.channels.native'),
}

function story(
  $window,
  $http,
  $q,
  $location,
  $interval,
  $timeout,
  $rootScope,
  storyTemplateService,
  contentTemplatesService,
  metaTemplatesService,
  padlockService,
  settingsService,
  findReplaceService,
  hyperlinkService,
  toastr,
  $ngRedux,
  fnService,
  uiStateManagerService,
  pharosService,
  $route,
  featureFlagService,
  $injector,
  getErrorMessage
) {
  const publishState = {}
  const snapshots = []
  const states = {}

  let story // Story object
  let orgSettings = {} // Client settings
  let picklists
  let saveRequested = false
  let redirect
  let activeSave = false // Track if in the process of saving
  let currentStep = 0
  let counter = 0
  let saveStartTime
  let _isDirty = false
  let isUrlRegenerated = false
  let warningMessagesStorage = []

  const isLegacyEnabled = $rootScope.globalSettings?.openBeta?.legacyEnabled

  const pushStoryState = (current) => {
    if (!snapshots[currentStep]) {
      return
    }
    let lastCE =
      snapshots[currentStep].content_elements ||
      snapshots[currentStep].contentElements ||
      snapshots[currentStep]
    if (typeof lastCE !== 'string') {
      lastCE = JSON.stringify(lastCE)
    }

    current = current || JSON.stringify(story.content_elements)
    let currCE = current.contentElements || current

    if (current.editableHTML) {
      const uCE = JSON.parse(current.contentElements)
      uCE[current.index].content = current.editableHTML[0]
      currCE = JSON.stringify(uCE)
    }

    const lState = lastCE.replace(/,"\$\$hashKey":"[^"]+"/gi, '')
    const cState = (typeof currCE === 'string'
      ? currCE
      : JSON.stringify(currCE)
    ).replace(/,"\$\$hashKey":"[^"]+"/gi, '')

    const isDifferent = lState !== cState

    console.info('isDifferent: ', isDifferent)
    console.log('push state', isDifferent, current, snapshots[currentStep])

    if (isDifferent) {
      snapshots.length = currentStep + 1
      snapshots.push(current)
      currentStep++

      while (snapshots.length > 200) {
        snapshots.shift()
        currentStep--
      }

      this.updateStoryState()
    }
    console.info('new length: ', snapshots.length)
    return isDifferent
  }

  this.pushStoryState = pushStoryState

  const resetStoryState = () => {
    snapshots.length = 0
  }

  this.resetStoryState = resetStoryState

  const pushContentElementState = () => {
    let details = {}
    const sel = document.getSelection()
    const elm = sel && sel.anchorNode
    const cntElm = (elm && elm.parentNode) || '.feature-focused'
    const ff = $(cntElm).closest('[content-element]')
    if (ff.length) {
      details = {
        index: ff.prevAll('[content-element]').length,
        editableHTML: ff
          .find('[contenteditablebind]')
          .map((i, elm) => elm.innerHTML)
          .get(),
        cursor: null,
      }
      // var cursorPartials = getTextBeforeAfterCursor(details.editableHTML[0])
      // var cursorPosition = getCurrentCursorIndex()  // <-- wrong
      /*
      if (cursorPosition !== null) {
        var orgHtml = details.editableHTML[0]
        details.editableHTML[0] = function () {
          var cursorPartials = splitHTMLAtIndex(orgHtml, cursorPosition)
          return cursorPartials.lead + '<span class="cursor-focus"></span>' + cursorPartials.tail
        }
        // details.editableHTML[0] = cursorPartials.lead + '<span class="cursor-focus"></span>' + cursorPartials.tail
      }
      */
    }
    details.contentElements = JSON.stringify(story.content_elements)
    console.log('pushContentElementState', details)
    return pushStoryState(details)
  }

  this.pushContentElementState = pushContentElementState

  // TODO : Use settings loaded in routes
  settingsService
    .fetchCompanySettings()
    .then((resp) => (orgSettings = resp.data))
  settingsService
    .fetchCompanySettings('picklists')
    .then((resp) => (picklists = resp.data))
    .catch((error) => {
      picklists = handlePicklistsError(error, toastr)
    })

  this.channels = channels

  this.isDirty = (setterValue) => {
    if (setterValue !== undefined) {
      _isDirty = setterValue
    }
    return _isDirty
  }

  this.sendToPrint = function (storyId, revisionId = null) {
    revisionId = revisionId || ''
    $http({
      method: 'GET',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/stp?story-id=${storyId}&revision-id=${revisionId}`,
      timeout: 100000,
    })
      .then(function () {
        toastr.clear()
        toastr.info(intl.get('story.sendToPrint.success'))
      })
      .catch(function () {
        toastr.clear()
        toastr.error(intl.get('story.sendToPrint.error'))
      })
  }

  this.setRoot = (res) => {
    $rootScope.template = res
    return Promise.resolve(res.data)
  }

  // Called from the story controller to fetch the story/template
  this.initialLoad = (details) => {
    let http
    story = null
    this.loadDetails = details

    // clean up undo/redo seems like it can stick EL-1435
    resetStoryState()

    const { branchId, revisionId, storyId, templateId } = details

    /* Existing story */
    if (storyId) {
      http = fetchStory(storyId, revisionId, branchId)
    } else if (templateId) {
      http = storyTemplateService.get(templateId)
    } else {
      throw new Error(intl.get('story.initialLoad.empty'))
    }

    return (
      http
        // when denormalize fail we need to catch it so we can tell user.
        // instead of blocking them from editing it, we can give them the portion
        // of the story they can edit.
        .then((res) => {
          if (res.status === 206) {
            if (res.data) {
              res.data.additional_properties =
                res.data.additional_properties || {}
              res.data.additional_properties._NOT_DENORMALIZED = true
            }
            toastr.clear()
            toastr.error(intl.get('story.initialLoad.error'))
          }
          return res
        })
        .then(this.setRoot)
        .then((nextStory) => {
          // line_count_planned migration
          const lineCountPlanned = get(
            nextStory,
            'planning.additional_properties.line_count_planned'
          )
          if (
            !!lineCountPlanned &&
            !get(nextStory, 'planning.story_length.line_count_planned')
          ) {
            set(
              nextStory,
              'planning.story_length.line_count_planned',
              lineCountPlanned
            )
            delete nextStory.planning.additional_properties.line_count_planned
          }

          if (!nextStory.content_elements) {
            return nextStory
          }
          nextStory.content_elements.forEach((ce) => {
            if (ce.type === 'text' && !ce.content?.length) {
              ce.content = '<br>'
            }
          })
          return nextStory
        })
        .then((nextStory) => inflateToANS(nextStory, picklists))
        .then((nextStory) =>
          inflateMissingContentElements(nextStory, picklists)
        )
        .then((nextStory) => inflatePicklists(nextStory, picklists))
        .then((nextStory) => handleOldFaultyPicklistOverrides(nextStory))
        .then((nextStory) => overridePicklists(nextStory, picklists))
        // This has to be run after overridePicklists after the source.name logic
        .then((nextStory) => {
          if (shouldPopulateDistributor(nextStory)) {
            populateDistributorFieldsFromSource(nextStory)
          }
          return nextStory
        })
        .then(giveContentElementsIds)
        .then(removeEmptyContentElementComments)
        .then((prevStory) => {
          // Only initialize paywall status on story creation
          if (!prevStory._id && orgSettings.updatePaywallStatusBasedOnSite) {
            return initializePaywallStatus(prevStory)
          }
          return prevStory
        })
        .then((story) => {
          // Add temp unique ID for each of the story tags
          const storyTags = story.taxonomy.tags
          if (storyTags.length === 0) return story // when no tags found
          return {
            ...story,
            taxonomy: {
              ...story.taxonomy,
              tags: storyTags.map((tag) => ({
                ...tag,
                tagId: ArcUUID.create(),
              })),
            },
          }
        })
        .then((story) => {
          // Draft app should get non-inflated inline comments
          $ngRedux.dispatch(storyLoadedAction(cloneDeep(story)))
          return inflateInlineComments(story)
        })
        .then(async (story) => {
          let circulations = []

          if (details.storyId) {
            try {
              circulations = await getAllCirculations(story._id)
            } catch (e) {
              console.error('Fetch circulations error! Reason:', e)
            }
          } else {
            circulations = getCirculationsFromStoryTemplate(story)
          }
          $ngRedux.dispatch(setCirculation(circulations))

          return story
        })
        .then((response) => {
          story = response
          $rootScope.story = story
          $rootScope.$broadcast(
            'ELLIPSIS_STORY_LOADED',
            story._id || 'new-story'
          )
          publishState.isPublished = response.additional_properties.is_published
          publishState.publishedDate =
            response.additional_properties.publish_date || ''

          if (
            ((response.related_content || false).redirect || false).length > 0
          ) {
            story.redirect = {
              forwardUrl: response.related_content.redirect[0].redirect_url,
            }
          }

          // MCO had an import bug, this is just to clean up the BUG until they get it fixed
          const sites = story.taxonomy && story.taxonomy.sites
          const temp = []

          function cleanUpSites(sites) {
            sites.forEach((o) => {
              if (Array.isArray(o)) {
                cleanUpSites(o)
              } else if (o && o.referent && !o.referent.id) {
                // Groupo seeing missing referent id
                console.log('Found referent with no id, skipping')
              } else if (o && typeof o === 'object') {
                temp.push(o)
              }
            })
          }

          if (sites && sites.length) {
            cleanUpSites(sites)
            if (temp.length) {
              story.taxonomy.sites = temp

              // Now MCO has dupes in the list, so clean that up
              const tempSiteIds = {}
              story.taxonomy.sites = story.taxonomy.sites.filter((s) => {
                if (tempSiteIds[s._id]) {
                  return false
                }
                tempSiteIds[s._id] = s._id
                return true
              })
            }
          }

          if (this.loadDetails.revisionId) {
            story.diffViewRevisionId = this.loadDetails.revisionId
          }

          snapshots.push(angular.copy(story))
          console.log(story)
          // initialize old WebSked Status for change detection
          $injector
            .get('webskedService')
            .initializeOldWebskedStatus(story.workflow.status_code)
          story.isDirty = false
          $ngRedux.dispatch(
            setStoryAns({
              storyAns: story,
              // Initial load should not set isDirty
              isDirty: false,
            })
          )

          return story
        })
        .catch((error) => {
          console.error('Story load error details:', error.data || error)

          toastr.clear()

          // If this is a JS error, surface the error message and report it
          if (isError(error)) {
            toastr.error(
              intl.get('story.loading.error', { reason: error.message })
            )
            pharosService.sendExceptionToSentry(error, error.message)
            return
          }

          const { status, statusText } = error

          // If this is a 404, immediately redirect the user to the "not found" page
          if (storyId && (status === 404 || statusText === 'Not Found')) {
            $location.path(`/storyNotFound/${storyId}`)
            return
          }

          // Check for the `errorKey` property where the Draft API response sets it;
          // fall back to the structure of the Story API response
          const errorKey = get(
            error,
            'data.error.errorKey',
            get(error, 'data.errorKey', '')
          )

          // The initial (i.e. fallback) value is simply the status text from the response
          let reason = `Reason: ${statusText}`
          if (status === 403 && errorKey.includes('noViewPerm')) {
            // This value is only needed for permissions-related errors
            const canonicalWebsite = get(
              error,
              'data.error.canonicalWebsite',
              get(error, 'data.canonicalWebsite', '')
            )
            // If this is not a website-specific permissions issue,
            // the second argument below will be ignored
            reason = intl.get(`story.initialLoad.permissions.${errorKey}`, {
              canonicalWebsite,
            })
          } else if (
            status === 403 &&
            (errorKey === 'noAccessPerm' || errorKey === 'authorNotFound')
          ) {
            $location.path(`/storyAccessDenied/${storyId}`)
            return
          } else if (status === 429) {
            reason = intl.get('errorReasons.rateLimit')
          } else if (errorKey.length > 0) {
            reason = intl.get(`errorReasons.${errorKey}`)
          }

          toastr.error(intl.get('story.loading.error', { reason }))
        })
    )
  }

  this.getStory = () => {
    const deferred = $q.defer()

    // Could use $rootScope.$watch...
    // TODO find a better solution??
    // better solution is to drive this off the promise that actually loads the story (initial load?)
    if (story) {
      deferred.resolve(story)
    } else {
      let count = 0
      const checkInterval = $interval(() => {
        if (story) {
          $interval.cancel(checkInterval)
          deferred.resolve(story)
        } else if (count === 10) {
          deferred.reject()
        }
        count++
      }, 1000)
    }

    return deferred.promise
  }

  // TODO: Get rid of this interval stuff
  let checkInterval

  this.getStoryPublishState = function () {
    const deferred = $q.defer()

    if (story) {
      deferred.resolve(publishState)
    } else {
      if (checkInterval) {
        $interval.cancel(checkInterval)
      }
      checkInterval = $interval(function () {
        if (story) {
          $interval.cancel(checkInterval)
          checkInterval = null
          deferred.resolve(publishState)
        }
      }, 1000)
    }

    return deferred.promise
  }

  // need public setter
  this.setStory = (obj, isDirty) => {
    story = obj
    $rootScope.$broadcast('STORY_SET', {
      story: story,
    })
    // Set isDirty if true/false is provided
    // Omitting isDirty will not change the dirty state
    if (typeof isDirty === 'boolean') {
      this.isDirty(isDirty)
    }
  }

  // public setter with deep set
  this.setStoryProp = (path = '', obj) => {
    path.split('.').reduce((acc, key, i, arr) => {
      if (i === arr.length - 1) acc[key] = obj
      return acc[key]
    }, story)
    this.isDirty(true)
  }

  // need public getter
  this.get = window.$$get = () => story

  // a better name for the above, slowly should remove .get references
  this.getStorySync = () => story

  this.saveAndRedirect = (
    path,
    ignoreCleanup = false,
    saveFromDraft = false
  ) => {
    redirect = path
    this.save(true, undefined, ignoreCleanup, false, saveFromDraft)
  }

  // should this receive the story obj?
  // public method that is called to execute save
  // ignoreValidation used when restoring from a past revision so it can be saved without errors
  this.save = function (
    force,
    ignoreValidation,
    ignoreCleanup,
    cloneStory,
    saveFromDraft = false
  ) {
    const isDraftApiStatefulEnabled = $rootScope.features.isEnabled(
      'draftApiStateful'
    )
    const deferred = $q.defer()

    if ($route.current.$$route.isDraftApp === true && !saveFromDraft) {
      $ngRedux.dispatch(
        saveAction({
          cloneStory,
        })
      )
      return
    }
    // Brodcast Event
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'saveCalled',
        activeSave,
      },
    })

    // clear find/replace
    findReplaceService.terminate()

    // Check User permissions for saving
    if (
      story._id &&
      story._id.length &&
      !hasPermission(
        window.userRolesAuth.story.editStory,
        story.canonical_website
      )
    ) {
      // throw auth error
      toastr.error(intl.get('story.save.permissions.error'))
      console.error('User does not have the rights to save')
      deferred.reject()
      return deferred.promise
    } else if (!story._id) {
      // on Create Story
      if (
        !hasPermission(
          window.userRolesAuth.story.createStory,
          story.canonical_website
        )
      ) {
        toastr.error(
          intl.get('story.create.permissions.error'),
          intl.get('common.error')
        )
        console.error('User does not have the rights to create new story')
        deferred.reject()
        return deferred.promise
      }
    }

    // Check User doesn't have Lock
    if (
      story._id &&
      !isDraftApiStatefulEnabled &&
      !padlockService.hasLock(story._id)
    ) {
      toastr.error(intl.get('story.save.lock.error'))
      console.error('User does not have the lock status to save')
      deferred.reject()
      return deferred.promise
    }

    // Check User is in a revision
    if (story.diffViewRevisionId) {
      deferred.reject('user is in a revision')
      return deferred.promise
    }

    // If a save is still running, we need to inform it we need to do it again.
    // This is checked when save is complete.
    if (activeSave) {
      saveRequested = true
      deferred.reject('debounced. save has not completed')
      return deferred.promise
    }

    // If story has no changes, than do not save
    if (!this.isDirty() && !force) {
      $rootScope.$broadcast('SAVE_CANCELED')
      deferred.reject('save canceled')
      return deferred.promise
    }

    saveStartTime = new Date()
    activeSave = true
    toastr.info(intl.get('story.save.saving'))

    storeLocal()

    return new Promise((resolve, reject) => {
      if (ignoreValidation) {
        resolve()
      } else {
        validateStory(
          story,
          orgSettings,
          metaTemplatesService.getMetaItems(),
          getCirculation($ngRedux.getState())
        ).then(({ errorMessages, warningMessages = [] }) => {
          if (errorMessages.length) {
            reject(errorMessages)
          } else {
            warningMessagesStorage = warningMessages
            resolve()
          }
        })
      }
    })
      .then(createIds)
      .then(cloneIfSpecified(cloneStory))
      .then(cleanUpStory(ignoreCleanup))
      .then(executeSave)
      .then((updatedStory) => {
        updatedStory.isDirty = false
        $ngRedux.dispatch(
          setStoryAns({
            storyAns: updatedStory,
            // Story should not be dirty after a save
            isDirty: false,
          })
        )
        return updatedStory
      })
      .catch((errorMessages) => {
        errorMessages = Array.isArray(errorMessages)
          ? errorMessages
          : [errorMessages]

        $rootScope.$broadcast('LOG_USER_EVENT', {
          event: {
            type: 'saveFailureValdation',
            executionTime: new Date().getTime() - saveStartTime.getTime(),
            error: errorMessages,
          },
        })
        activeSave = false

        toastr.clear()
        const toastrTitle = `${intl.get('common.error')}: ${intl.get(
          'story.save.validateStory.error'
        )}`
        const errorsTranslated = errorMessages.map((message) => {
          let translatedMessage

          if (message.toLowerCase().includes('working headline')) {
            translatedMessage = intl.get(
              'story.save.validationMessages.workingHeadline'
            )
          } else if (message.toLowerCase().includes('default headline')) {
            translatedMessage = intl.get(
              'story.save.validationMessages.defaultHeadline'
            )
          } else {
            translatedMessage = message
          }

          return translatedMessage
        })
        toastr.error(errorsTranslated.join('<br />'), toastrTitle, {
          allowHtml: true,
          timeOut: 20000,
        })

        deferred.reject(errorMessages)
        return deferred.promise
      })
  }
  const save = this.save.bind(this)

  $rootScope.$on('SAVE_STORY', save)

  // We have to keep these event listeners since using storyService.setStory might break some components
  // if they're mutatING story directly by initial reference
  const onPublishedOrScheduled = ($event, { storyObj }) => {
    story.revision = storyObj.revision
    story.canonical_url = storyObj.canonical_url
    story.websites = storyObj.websites
  }
  $rootScope.$on('STORY_PUBLISHED', onPublishedOrScheduled)
  $rootScope.$on('STORY_SCHEDULED', onPublishedOrScheduled)

  const cloneIfSpecified = (cloneStory) => () => {
    const deferred = $q.defer()

    if (cloneStory && story._id) {
      const parentCirculations = getCirculation($ngRedux.getState()) || []

      cloneService.createLocalCloneOfStory(story, parentCirculations)
    }

    deferred.resolve()
    return deferred.promise
  }

  this.restoreRevision = (revisionId) => {
    const revisionStory = story['rev' + revisionId]
    if (revisionStory) {
      revisionStory.revision = story.revision
      // copy over revision so it has the right parent id
      story = revisionStory

      /// branch/${story.revision.branch}

      const redirectUrl = isLegacyEnabled
        ? `edit/${story._id}`
        : `edit/${story._id}?allowAngular=true`

      this.saveAndRedirect(redirectUrl, true)
    } else {
      console.log('ERROR')
    }
  }

  // public method that is called to execute delete
  this.delete = () => {
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'delete',
      },
    })

    const deferred = $q.defer()

    // If it is brand new, just say it is deleted
    if (!story._id) {
      deferred.resolve({
        data: {
          deleted: true,
        },
      })
    } else if (
      !hasPermission(
        window.userRolesAuth.story.deleteStory,
        story.canonical_website
      )
    ) {
      // if the user does not have permission to delete
      toastr.error(intl.get('story.delete.permissions.error'))
      console.error('User does not have the rights to delete')
      deferred.reject()
    } else {
      let deletePromise
      deletePromise = deleteStory(story._id, $ngRedux.dispatch).then(() => ({
        data: {
          deleted: true,
        },
      }))

      deletePromise.then(
        (response) => {
          story = null
          deferred.resolve(response)
        },
        (response) => {
          toastr.error(intl.get('story.delete.error'))
          console.error('Cannot delete the story.', response)
          deferred.reject(response)
        }
      )
    }
    return deferred.promise
  }

  this.updateStoryState = () => {
    states.step = ++counter
    states.canUndo = currentStep > 0
    states.canRedo = currentStep < snapshots.length - 1
    $rootScope.$broadcast('DISPATCH', {
      event: {
        type: 'UNDO_REDO_STATE',
        states,
      },
    })
  }
  const updateStoryState = this.updateStoryState.bind(this)
  this.fetchStoryState = () => {
    return states
  }

  const updateContentElements = () => {
    const csh = snapshots[currentStep]
    const isArr = Array.isArray(csh)
    let contentElems = csh.content_elements
    contentElems =
      contentElems || JSON.parse(isArr ? csh : csh.contentElements || `[]`)
    if (!contentElems || !contentElems.length) {
      return
    }
    story.content_elements.length = 0
    story.content_elements.push(...contentElems)
    if (!isArr) {
      $timeout(() => {
        $('[content-element]')
          .eq(csh.index)
          .find('[contenteditablebind]')
          .each((i, e) => {
            const temp = csh.editableHTML[i]
            const isFunc = typeof temp === 'function'
            e.innerHTML = isFunc ? temp() : temp
            // $rootScope.$broadcast('DISPATCH', {
            $(document).trigger('BROADCAST.wc', {
              type: constants.WORDCOUNT,
              orgIndex: csh.index,
              content: e.textContent.trim().replace(/(&nbsp;|\s)+/g, ' '),
            })
          })
        lookForCursorFocus()
      })
    }
    updateStoryState()
  }

  let cfTimer = null
  const lookForCursorFocus = (cnt) => {
    if (!cnt) {
      cnt = 1
    }
    if (cfTimer) {
      window.clearTimeout(cfTimer)
    }
    const cf = document.querySelector('span.cursor-focus')
    if (cf) {
      const pe = cf.closest('[contenteditablebind]')
      if (pe) {
        pe.blur()
      }
      cf.focus()
      const range = document.createRange()
      range.setStartAfter(cf)
      range.collapse(true)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      cf.remove()
    } else if (cnt < 1000) {
      cfTimer = window.setTimeout(lookForCursorFocus, 5, cnt++)
    }
  }

  const navActionsUndo = () => {
    if (currentStep > 0) {
      currentStep--
      updateContentElements()
    }
    console.log('undo: ', currentStep, ' of ', snapshots.length - 1)
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'undo',
        currentStep,
      },
    })
  }

  const navActionsRedo = () => {
    if (currentStep < snapshots.length - 1) {
      currentStep++
      updateContentElements()
    }
    console.log('redo: ', currentStep, ' of ', snapshots.length - 1)
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'redo',
        currentStep,
      },
    })
  }

  this.execRedo = navActionsRedo
  this.execUndo = navActionsUndo

  uiStateManagerService.onStateChange('navActionsUndo', navActionsUndo)
  uiStateManagerService.onStateChange('navActionsRedo', navActionsRedo)

  // @returns {array<number>} - returns array ofindices of filtered content element type
  this.getContentElementPositions = function () {
    const ce = story.content_elements || []
    if (ce.length < 1) {
      return []
    }
    return ce.reduce((acc, obj, i) => [...acc, i], [])
  }

  const storeLocal = () => {
    if (!story._id) return

    const txt = angular
      .element('#story-wrapper')
      .contents()
      .not('[content-editable="false"]')
      .text()
      .replace(/\s+\n+/g, '\n')
      .replace(/( )+/g, ' ')
      .replace(/(^ +| +$)/g, '')
    const bus = window.localStorage.backup || '[]'
    let backUp = JSON.parse(bus)

    if (backUp.length && txt.length && backUp[0].t === txt) return
    backUp.unshift({
      id: story._id,
      d: new Date().getTime(),
      t: txt,
    })

    if (backUp.length > 10) {
      backUp = backUp.slice(0, 10)
    }
    try {
      window.localStorage.backup = JSON.stringify(backUp)
    } catch (e) {
      console.log('Can not store story to localStorage', e)
    }
  }

  // Grab the story from the story api
  function fetchStory(storyId, revisionId, branchId) {
    // remove revision flag and refactor when revision logic exists
    return revisionId
      ? storyServicePubstackUtils.getDiffWithLegacyRevision(storyId, revisionId)
      : getStoryPubstack(storyId).then(({ status, data }) => {
          $ngRedux.dispatch(setDocumentAction(data.document))
          $ngRedux.dispatch(setDraftRevisionAction(data.revision))
          return {
            status,
            data: data.legacyStory,
          }
        })
  }

  function old_validateStory(ignoreValidation) {
    const deferred = $q.defer()
    let hasError = false
    let errors = []
    let errorMessages = []
    const requiredKeys = {}

    // For revisions, a past revision may not be valid so we skip validation
    if (ignoreValidation) {
      deferred.resolve()
      return deferred.promise
    }

    if (orgSettings && orgSettings.v2) {
      // see util/handleRequired for this
      errors = metaTemplatesService
        .requiredForSave(orgSettings.v2, story)
        .filter((o) => o.missing === true)
      errorMessages = errors.map((o) =>
        intl.get('story.save.validationMessages.missingField', {
          missingValue: o.label,
        })
      )
      hasError = errorMessages.length > 0
    } else if (
      !story.headlines ||
      !story.headlines.basic ||
      !story.headlines.basic.length
    ) {
      requiredKeys.working_headline = true
      errorMessages.push(
        intl.get('story.save.validationMessages.workingHeadline')
      )
      hasError = true
    } else {
      requiredKeys.working_headline = false
    }

    if ((story.redirect || false).forwardUrl) {
      try {
        story.redirect.forwardUrl.startsWith('/')
          ? new URL(story.redirect.forwardUrl, window.location.origin)
          : new URL(story.redirect.forwardUrl)
      } catch (error) {
        errorMessages.push(intl.get('story.save.validateStory.redirectUrl'))
        hasError = true
      }
    }
    $rootScope.$broadcast('DISPATCH', {
      type: 'REQUIRED_FIELDS',
      fields: errors.filter((e) => e.missing === true),
    })

    if (hasError) {
      deferred.reject(errorMessages)
    } else {
      deferred.resolve()
    }

    return deferred.promise
  }

  function createIds() {
    const uuidFactory = () => ArcUUID.create()
    story.content_elements.forEach((elem) => {
      if (!elem._id || !elem._id.length) {
        elem._id = uuidFactory()
      }
      // If the template has a getIds method, than run it
      const setIds = contentTemplatesService.setIdsMethod(elem.type)
      if (setIds) {
        setIds(uuidFactory, elem)
      }
    })

    const deferred = $q.defer()
    deferred.resolve()
    return deferred.promise
  }

  const hasInlineComments = (element) =>
    get(element, 'additional_properties.inline_comments.length') > 0

  // remove the non ans stuff
  const cleanUpStory = (ignoreCleanup) => () => {
    const deferred = $q.defer()
    // downstream smart quote conversion hotfix
    // story.content_elements = downstreamConvert(story.content_elements)
    // API expects the parent id to be the current revision number, so need to swap.
    if (story.revision && story.revision.revision_id) {
      story.revision.parent_id = story.revision.revision_id // set the parent to the current revision of the last save
      delete story.revision.revision_id // remove the revision id, the server will set it
      delete story.revision.index // ans yelling at me for invalid prop index?
    }

    // API expects display_date to be date
    if (story.display_date === null) {
      delete story.display_date
    }

    // Clean up Circulation in story obj on Create/Save Story
    if (story.circulations) {
      delete story.circulations
    }

    // Ignore cleanup during revision restore. No cleanup needed as data went from
    // content API and has been already cleaned up.
    if (ignoreCleanup) {
      deferred.resolve(JSON.stringify(story))
      return deferred.promise
    }

    // Dirty flag check on the content elements
    $rootScope.$broadcast('BEFORE_SAVE', {})

    if (
      orgSettings.removeEmptyParagraphs &&
      !$route.current.$$route.isDraftApp
    ) {
      // abstract it for unit testing
      story.content_elements = removeEmptyParagraphs(story.content_elements)
    }

    story.content_elements.forEach((elem) => {
      const type = elem.type

      // el-466 el nacion problem
      if (['text', 'blockquote', 'header'].indexOf(type) > -1) {
        const compact = !hasInlineComments(elem)
        elem.content = htmlTextReducer(elem.content, compact)
      }
      // Lists
      if (type === 'list') {
        elem.items = elem.items.map((item) => {
          if (item.type === 'text') {
            const compact = !hasInlineComments(item)
            return {
              ...item,
              content: htmlTextReducer(item.content, compact),
            }
          } else {
            return item
          }
        })
      }

      //  EL-1139 - have a new element with type "quote" and subtype "blockquote".  This co-exists with the other content element that has type "quote" and subtype "pullquote".  The type "quote2" is necessary in order for drag and drop to work on the frontend
      if (type === 'quote2') {
        elem.type = 'quote'
      }

      // If the template has a beforeSave method, than run it
      const beforeSave = contentTemplatesService.beforeSaveMethod(type)
      if (beforeSave) {
        beforeSave(elem)
      }
    })

    let clonedStory = JSON.stringify(story)
    clonedStory = clonedStory
      .replace(/"\$\$hashKey":"[^"]*",/g, '')
      .replace(/,\s?"\$\$hashKey":"[^"]*"/g, '')

    if (clonedStory.match(/[\u0002\u0001]/g)) {
      clonedStory = clonedStory.replace(/[\u0002\u0001]/g, '')
    }

    // Detect is Grammarly was used, if it was, clean it up.
    const unattachedData = JSON.parse(clonedStory)

    // Adding code to clean up bad paste data that might be in the content api right now. This finds our HTML and removes it.
    unattachedData.content_elements.forEach((ce) => {
      if (['raw_html', 'code'].indexOf(ce.type) > -1) {
        return
      } else if (ce.type === 'list') {
        ce.items.forEach((itm) => {
          if (itm.content && itm.content.indexOf('<dfn') > -1) {
            ce.additional_properties = ce.additional_properties || {}
            ce.additional_properties.comments =
              ce.additional_properties.comments || []

            const elm = $('<div/>').html(itm.content)
            const dfns = elm.find('dfn')
            const comment = {
              text: dfns.text(),
              email: '',
              user: '',
              date: '',
            }
            if (ce.additional_properties.comments.length) {
              ce.additional_properties.comments[0].replies =
                ce.additional_properties.comments[0].replies || []
              ce.additional_properties.comments[0].replies.push(comment)
            } else {
              ce.additional_properties.comments.push(comment)
            }
            dfns.remove()
            itm.content = elm.html()
          }
        })
      }

      if (
        ce.content &&
        (ce.content.indexOf('feature-menu') !== -1 ||
          ce.content.indexOf('feature-obj') !== -1 ||
          ce.content.indexOf('ng-') !== -1 ||
          ce.content.indexOf('<mark') !== -1)
      ) {
        // TODO: Mike: no jquery here
        const temp = $('<div></div>').html(ce.content.replace(/\n/g, ' '))
        temp.find('.handles').remove()
        if (ce.type === 'text') {
          temp.find('p, h1, mark.el-find-result').each((i, el) => {
            // TODO: Mike: no jquery here
            const p = $(el)
            if (p.html().length) {
              p.contents().unwrap()
            } else {
              p.remove()
            }
          })
        }
        ce.content = temp.html().trim()
      }
      // lanacion-cr with bug in RSS caused by \x01
      /* eslint no-control-regex: "off" */
      if (ce.content && ce.content.match(/\x01/)) {
        ce.content = ce.content.replace(/\x01/g, '')
      }

      if (ce.content && ce.content.match(/[\u0002\u0001]/g)) {
        ce.content = ce.content.replace(/[\u0002\u0001]/g, '')
      }

      if (ce.content && ce.content.match(/&nbsp;/)) {
        ce.content = ce.content.replace(/&nbsp;/g, ' ')
        if (!hasInlineComments(ce)) {
          ce.content = ce.content.replace(/\s+/g, ' ')
        }
      }
    })

    // remove inline comments from content and add data into inline_comments structure
    unattachedData.content_elements = deflateInlineComments(
      unattachedData.content_elements
    )
    removeBRPlaceholders(unattachedData)

    if (unattachedData.revision) {
      unattachedData.revision.editions = []
    }

    metaTemplatesService.beforeSaveMethod(unattachedData)

    const ceStr = JSON.stringify(unattachedData.content_elements)
    if (
      ceStr.indexOf('data-grammarly-reactid') !== -1 ||
      ceStr.indexOf('data-gr-id') !== -1
    ) {
      for (let i = unattachedData.content_elements.length - 1; i >= 0; i--) {
        const ce = unattachedData.content_elements[i]
        if (ce.content && ce.content.length) {
          if (ce.content.indexOf('data-gr-id') !== -1) {
            // TODO: Mike: no jquery here
            // error wrapping around 'words'
            let temp = $('<div></div>').html(ce.content)

            temp.find('[data-gr-id]').each(function () {
              // TODO: Mike: no jquery here
              // remove the <g> element
              $(this).contents().unwrap()
            })
            ce.content = temp.html()
            temp = null
          } else if (
            ce.content.indexOf('data-grammarly-reactid') !== -1 ||
            ce.content?.length === 0
          ) {
            // hidden elements
            // remove the hidden element (aka empty paragraph)
            unattachedData.content_elements.splice(i, 1)
          }
        }
      }
    }

    // Moved some logic to React flow cleanupStory module, running data through it here
    const circulations = getCirculation($ngRedux.getState())
    const storyFromReactModule = storyCleanup(unattachedData, circulations)

    clonedStory = JSON.stringify(storyFromReactModule)

    deferred.resolve(clonedStory)
    return deferred.promise
  }

  const saveSuccess = async (response) => {
    let repubMsgText
    const reduxState = $ngRedux.getState()
    const scheduleDate = reduxState.storyData.scheduleStatus.publish
    const timezone = reduxState.settings.timezone
    const updatedStory = response.data
    const pubMessage =
      publishState.isPublished || scheduleDate ? repubMsgText : ''
    const toastConfigs = {
      closeButton: true,
      timeOut: 300000,
      extendedTimeOut: 300000,
      tapToDismiss: false,
    }

    if (isUrlRegenerated) {
      repubMsgText = intl.get('story.saveSuccess.urlRegen')
      this.toggleUrlRegenFlag()
    } else if (scheduleDate) {
      const resultDate = format(
        utcToZonedTime(new Date(scheduleDate), timezone),
        'MM/dd/yyyy HH:mm a',
        { timeZone: timezone }
      )
      repubMsgText = `${intl.get(
        'story.saveSuccess.schedulePubMsg'
      )} ${resultDate}`
    } else {
      repubMsgText = intl.get('story.saveSuccess.pubstackRepubMsg')
    }

    // Toast messages
    toastr.clear()
    toastr.success(
      pubMessage,
      intl.get('story.saveSuccess.success'),
      pubMessage ? toastConfigs : {}
    )
    if (warningMessagesStorage.length) {
      toastr.warning(warningMessagesStorage.join('<br/>'), {
        ...toastConfigs,
        allowHtml: true,
      })
    }

    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'saveSuccess',
        executionTime: new Date().getTime() - saveStartTime.getTime(),
      },
    })

    // If successfuly saved, the story isn't dirty any more
    _isDirty = false

    // On Creating Story
    if (!story._id && !redirect) {
      //  a new story has been created

      $rootScope.$broadcast('SAVE_SUCCESS', {
        story,
      })
      $rootScope.$broadcast('NEW_REVISION', {
        display_date: response.data.display_date,
        revision: response.data.revision,
      })

      if ((story.related_content.clonedFromParent || []).length > 0) {
        //  this is a cloned story that was just created

        activeSave = false

        //  save the original story (with the updated "clonedChildren" record)
        //  and redirect to the cloned story
        cloneService.addClonedStoryToParent(updatedStory)
        story = cloneService.getParentStory()

        // clone parent's circulations to child document (bypassing stateful initially)
        if (
          !$rootScope.features.isEnabled('draftApiStateful') &&
          !(
            orgSettings.circulations && orgSettings.circulations.omitWhenCloning
          )
        ) {
          const parentCirculations = cloneService.getParentCirculations()
          if (parentCirculations.length) {
            try {
              const modifiedCircs = parentCirculations.map((circ) => {
                return {
                  ...circ,
                  website_url: '',
                  document_id: updatedStory._id,
                }
              })
              await bulkSaveCirculations(modifiedCircs, updatedStory._id, true)
            } catch (error) {
              localStorage.setItem(
                'circulationStoryCloneError',
                JSON.stringify({
                  error: error,
                  storyId: updatedStory._id,
                })
              )
            }
          }
        }

        const redirectUrl = isLegacyEnabled
          ? `story/${updatedStory._id}/`
          : `story/${updatedStory._id}/?allowAngular=true`

        this.saveAndRedirect(redirectUrl, false, true)
        return story
      }

      // Update URL with the id - do not cause redirect
      story._id = updatedStory._id

      const circulations = getCirculation($ngRedux.getState())
      try {
        await bulkSaveCirculations(circulations, story._id)
      } catch (error) {
        localStorage.setItem(
          'circulationStoryCreateError',
          JSON.stringify({
            error: error,
            storyId: story._id,
          })
        )
      }

      const redirectUrl = isLegacyEnabled
        ? `${process.env.ROUTE_BASE_PATH}/edit/${story._id}/`
        : `${process.env.ROUTE_BASE_PATH}/edit/${story._id}/?allowAngular=true`

      window.location.href = redirectUrl
      return story
    }

    // Update fields that are updated on server
    story.created_date = updatedStory.created_date
    story.last_updated_date = updatedStory.last_updated_date
    story.publish_date = updatedStory.publish_date
    story.first_publish_date = updatedStory.first_publish_date
    story.revision = updatedStory.revision

    // TODO - figure out a generic way to do this....
    updatedStory.content_elements.forEach(function (feature, index) {
      if (
        feature.type === 'oembed_response' &&
        story.content_elements[index].type === 'reference'
      ) {
        story.content_elements[index] = feature
      }
    })

    $rootScope.$broadcast('SAVE_SUCCESS', {
      story: story,
    })
    $rootScope.$broadcast('NEW_REVISION', {
      display_date: response.data.display_date,
      revision: response.data.revision,
    })

    try {
      await $injector.get('webskedService').updateWebskedStatus(story)
    } catch (error) {
      toastr.error(
        intl.get('WebskedButtons.updateStatus.errorWithMsg', {
          errorMessage: getErrorMessage(
            error,
            'Error while updating websked status in Websked Service'
          ),
        }),
        intl.get('common.error')
      )
    }

    if (redirect) {
      window.location.href = redirect
      redirect = ''
    }

    // If they clicked save when other save has happening that try again.
    activeSave = false
    if (saveRequested) {
      saveRequested = false
      save(true)
    }

    return story
  }

  function saveFailure(errorResponse) {
    const deferred = $q.defer()
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'saveFailure',
        executionTime: new Date().getTime() - saveStartTime.getTime(),
        error: errorResponse,
      },
    })

    activeSave = false
    toastr.clear()
    if (warningMessagesStorage.length) {
      toastr.warning(warningMessagesStorage.join('&#32;'), toastConfigs)
    }

    console.error(
      'Story save error details:',
      errorResponse.data || errorResponse
    )

    const errorMessages = []

    if (errorResponse.status === 412) {
      $('#wrongRevisionIdModal').modal('show')
    } else if (
      errorResponse.status === 422 &&
      errorResponse.data.field === 'revision.parent_id'
    ) {
      errorMessages.push(intl.get('story.save.validateStory.incorrectParentId'))
      // TODO: Mike: no jquery here
      // show be a message
      $('#wrongRevisionIdModal').modal('show').data('details', errorResponse)
    } else if (errorResponse.status === 400) {
      errorMessages.push(errorResponse.data.error_message)
    } else if (
      errorResponse.status === 403 &&
      ['noAccessPerm', 'authorNotFound'].includes(errorResponse.errorKey)
    ) {
      errorMessages.push(intl.get('errorReasons.errorReasons.noAccessPerm'))
    } else {
      const errorMessage = isString(errorResponse.data)
        ? errorResponse.data
        : intl.get(`errorReasons.${errorResponse.data.errorKey}`)

      errorMessages.push(
        `${errorResponse.status} error${
          errorResponse.statusText ? ` (${errorResponse.statusText})` : ''
        }: ${get(errorResponse, 'data.message', errorMessage)}`
      )
    }

    deferred.reject(errorMessages)
    return deferred.promise
  }

  function executeSave(clonedStory) {
    const storyData = JSON.parse(clonedStory)

    const updateOrCreatePromise = storyData._id
      ? updateDraftRevision(storyData._id, storyData, $ngRedux.dispatch)
      : createStoryPubstack(storyData, $ngRedux.dispatch)

    return updateOrCreatePromise
      .then((data) => {
        const { revision, document, legacyStory } = data

        $ngRedux.dispatch(setDocumentAction(document))
        $ngRedux.dispatch(setDraftRevisionAction(revision))

        return saveSuccess({
          data: legacyStory,
        })
      })
      .catch((response) => {
        return saveFailure({
          status: response.status,
          statusText: response.statusText,
          data: response.data || response.errorData || response,
          errorKey: response.errorKey,
        })
      })
      .finally(() => {
        warningMessagesStorage = []
      })
  }

  this.toggleUrlRegenFlag = function () {
    return (isUrlRegenerated = !isUrlRegenerated)
  }

  /**
   * Fetch the variants from the story.
   * Only enabled with the feature flag
   */
  this.getVariants = async (storyId) => {
    await fetchVariants({
      dispatch: $ngRedux.dispatch,
      storyId,
    })
  }
}
